import { render, staticRenderFns } from "./Acessos.vue?vue&type=template&id=3e52a75b&scoped=true"
import script from "./Acessos.vue?vue&type=script&lang=js"
export * from "./Acessos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e52a75b",
  null
  
)

export default component.exports